var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{staticClass:"ui-head"},[_vm._t("head")],2),_c('p',{staticClass:"ui-subhead",class:_vm.SubHeadAlign},[_vm._t("subhead")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }